import { processTag } from '../../render/update/processTag.function.js';
import { processNewSubjectTag } from './processNewSubjectTag.function.js';
export function processTagInit(value, contextItem, ownerSupport, counts, appendTo, insertBefore) {
    if (appendTo) {
        return processNewSubjectTag(value, contextItem, ownerSupport, counts, appendTo, insertBefore);
    }
    return processTag(ownerSupport, contextItem, counts);
}
